module.exports = __webpack_public_path__ + "resources/icon-letter-no-prize-bg.eb344c98aca9a971.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-rolling/img/icon-letter-no-prize-bg.png
// module id = 830
// module chunks = 0 1